// extracted by mini-css-extract-plugin
export default {"cls1":"PayeeCreateForms-StepContent_cls1__qyj1i","cls2":"PayeeCreateForms-StepContent_cls2__j639o PayeeCreateForms-StepContent_cls1__qyj1i"};